<nav class="tab-navigation">
  @for (tab of tabs; track tab.id) {
    <button class="tab-item" [class.active]="activeTab === tab.id" (click)="tabChange.emit(tab.id)">
      {{ tab.label }}
    </button>
  }
</nav>
